class AboutFaq {
  constructor() {
    const root = document.querySelector('.about-faq');

    if (root) {
      const items = root.querySelectorAll('.about-faq__item');

      items.forEach(item => item.addEventListener('click', () => this.toggleItem(item)));
    }
  }

  toggleItem(el) {
    const items = document.querySelectorAll('.about-faq__item');

    items.forEach(item => {
      const content = item.querySelector('.about-faq__item__content');
      const desc = item.querySelector('.about-faq__item__desc');

      if (el == item) {
        item.classList.toggle('active');

        if (item.classList.contains('active')) {
          content.style.height = `${desc.getBoundingClientRect().height}px`;
        }
        else {
          content.style.height = 0;
        }
      }
      else {
        item.classList.remove('active');
        content.style.height = null;
      }
    });
  }
}

export default AboutFaq;
